/** Measurement panel unit priority (lower value wins): segment (i/L) > height H. */
const MEASUREMENT_PANEL_TEXT_PRIORITY = {
    segment: 0,
    height: 1,
};
/** Strict rectangle intersection; touching edges do not count as overlap. */
function rectsIntersect(a, b) {
    return (a.left < b.right && b.left < a.right && a.top < b.bottom && b.top < a.bottom);
}
/** Groups boxes into units: i/L of the same segment share one unit, each H is its own. */
function buildMeasurementTextUnits(boxes) {
    const units = [];
    const unitBySegment = new Map();
    boxes.forEach((box, index) => {
        if (box.key.kind === "height") {
            units.push({
                priority: MEASUREMENT_PANEL_TEXT_PRIORITY.height,
                anchorX: box.anchorX,
                indices: [index],
            });
            return;
        }
        const unit = unitBySegment.get(box.key.segmentIndex);
        if (unit) {
            unit.indices.push(index);
            return;
        }
        const newUnit = {
            priority: MEASUREMENT_PANEL_TEXT_PRIORITY.segment,
            anchorX: box.anchorX,
            indices: [index],
        };
        unitBySegment.set(box.key.segmentIndex, newUnit);
        units.push(newUnit);
    });
    return units;
}
/**
 * Decides which measurement panel texts stay visible, in priority then left-to-right order.
 * Same-segment i/L form one unit; a unit is hidden as a whole if any of its texts
 * intersects an already accepted text.
 * @returns visibility flags in the same order as `boxes`
 */
export function selectVisibleMeasurementTexts(boxes) {
    const units = buildMeasurementTextUnits(boxes).sort((a, b) => a.priority - b.priority || a.anchorX - b.anchorX);
    const visible = boxes.map(() => false);
    const accepted = [];
    for (const unit of units) {
        const rects = unit.indices.map((index) => boxes[index].rect);
        const blocked = rects.some((rect) => accepted.some((other) => rectsIntersect(rect, other)));
        if (blocked)
            continue;
        for (const index of unit.indices)
            visible[index] = true;
        accepted.push(...rects);
    }
    return visible;
}
/**
 * Computes the screen center of a vertical marker label.
 * The label's top end sits `clearancePx` below the anchor; no panel or overlap avoidance.
 */
export function computeVerticalLabelPlacement(input) {
    return {
        x: input.anchor.x,
        y: input.anchor.y + input.clearancePx + input.lengthPx / 2,
    };
}
/**
 * Computes the screen y where a CP's vertical dashed line starts.
 * Starts `gapPx` below the CP name label, capped at the panel top.
 * Without a label, starts at the triangle bottom.
 */
export function computeVerticalLineStartY(input) {
    if (input.labelBottomY === null)
        return input.markerBottomY;
    const belowLabel = Math.min(input.labelBottomY + input.gapPx, input.panelTopY);
    return Math.max(belowLabel, input.markerBottomY);
}
//# sourceMappingURL=altitude-view-label-layout.js.map